"use client"

import {Controller, FieldValues, Path, useFormContext} from "react-hook-form"
import AppInput from "@/app/components/atomic/Input/AppInput"

export const Asterisk = () => <span className="text-red-500">*</span>

export function FieldError({message}: {message?: string}) {
    if (!message) return null
    return <p className="text-[12px] text-red-600">{message}</p>
}

export function ContactTextField<T extends FieldValues>({name, label}: {name: Path<T>; label: string}) {
    const {control} = useFormContext<T>()
    return (
        <Controller
            name={name}
            control={control}
            render={({field, fieldState}) => (
                <div className="flex flex-col gap-2">
                    <label className="font-semibold text-rm-14" htmlFor={name}>{label}<Asterisk /></label>
                    <AppInput
                        id={name}
                        fieldName={name}
                        borders="neutral"
                        value={field.value}
                        onChange={({value}) => field.onChange(value)}
                    />
                    <FieldError message={fieldState.error?.message} />
                </div>
            )}
        />
    )
}
